export const headerMenuItems = [
  { name: 'Home', title: 'Погрузки' },
  { name: 'Contragents', action: 'carriers', title: 'Перевозчики' },
  { name: 'Auto-list', action: 'Auto-list', title: 'Автопарк' },
  { name: 'Driver-list', action: 'Driver-list', title: 'Водители' },
  { name: 'Flights', action: 'Flights', title: 'Рейсы' },
  { name: 'Reports', requireAdmin: true, title: 'Отчеты' },
  { name: 'Managers', action: 'Managers-list', title: 'Менеджеры' },
  { name: 'EdmUsers', requireAdmin: true, title: 'Пользователи ЭДО' },
  { name: 'Users', requireAdmin: true, title: 'Пользователи' },
  { name: 'ClientsSettings', requireAdmin: true, title: 'Заказчики' },
  { name: 'CallCenter', requireAdmin: true, title: 'Колл-центр' },
  {
    name: 'User-organizations',
    requireAdmin: true,
    title: 'Орг. пользователя',
  },
  {
    name: 'Approvals',
    action: 'Approvals-list',
    title: 'На проверку',
    titleTemplate: 'На проверку',
  },
  {
    name: 'UnknownFiles',
    action: 'unknownFilesMenu',
    title: 'Работа с файлами',
  },
  { name: 'Documents', action: 'Documents-list', title: 'Документы' },
  {
    name: 'TableOfPayments',
    action: 'TableOfPayments',
    title: 'Таблица платежей',
  },
  {
    name: 'RegisterOfPayments2',
    action: 'RegisterOfPayments2',
    title: 'Реестр оплат2',
  },
  {
    name: 'RegisterOfPayments',
    action: 'RegisterOfPayments',
    title: 'Реестр оплат',
  },
  {
    name: 'Timeslots',
    blankLink:
      'https://port-tranzit.ru/apiexp/gettimeslotsforus?token=729ed0986372807c7f0376df94f7425cba26b8a8',
    requireAdmin: true,
    title: 'Таймслоты',
  },
]

export const mobileMenuItems = {
  admin: [
    {
      id: 1,
      title: 'Заявки',
      children: [
        { id: 10, title: 'Заявки', path: '/home' },
        { id: 11, title: 'Калькулятор', path: '/calculator' },
        { id: 12, title: 'Добавить заявку', path: '/shipping/add' },
      ],
    },
    {
      id: 2,
      title: 'Мои авто',
      children: [
        { id: 21, title: 'Мои авто', path: '/autos-mobile' },
        { id: 22, title: 'Добавить авто', path: '/auto-add-mobile' },
        { id: 23, title: 'Поиск рейсов', path: '/flights-mobile' },
      ],
    },
    {
      id: 3,
      title: 'Водители',
      children: [
        { id: 31, title: 'Водители', path: '/drivers-mobile' },
        { id: 32, title: 'Добавить водителя', path: '/driver-add-mobile' },
      ],
    },
    {
      id: 4,
      title: 'Профиль',
      children: [
        { id: 41, title: 'Мой профиль', path: '/user' },
        { id: 42, title: 'Перевозчики', path: '/contragents' },
        { id: 43, title: 'Выход', clickable: true, action: 'logout' },
      ],
    },
  ],
  exporter: [
    {
      id: 1,
      title: 'Заявки',
      children: [
        { id: 10, title: 'Заявки', path: '/home' },
        { id: 11, title: 'Добавить заявку', path: '/shipping/add' },
      ],
    },
    {
      id: 2,
      title: 'Мои авто',
      children: [{ id: 21, title: 'Мои авто', path: '/autos-mobile' }],
    },
    {
      id: 3,
      title: 'Водители',
      children: [{ id: 31, title: 'Водители', path: '/drivers-mobile' }],
    },
    {
      id: 4,
      title: 'Профиль',
      children: [
        { id: 41, title: 'Мой профиль', path: '/user' },
        { id: 43, title: 'Выход', clickable: true, action: 'logout' },
      ],
    },
  ],
  dispatcher: [
    { id: 1, title: 'Заявки', path: '/home' },
    { id: 2, title: 'Мои авто', path: '/autos-mobile' },
    { id: 3, title: 'Водители', path: '/driver/list' },
    {
      id: 4,
      title: 'Профиль',
      children: [
        { id: 41, title: 'Мой профиль', path: '/user' },
        { id: 42, title: 'Перевозчики', path: '/contragents' },
        { id: 43, title: 'Выход', clickable: true, action: 'logout' },
      ],
    },
  ],
  contragent: [
    {
      id: 1,
      title: 'Заявки',
      children: [{ id: 11, title: 'Предложения о работе', path: '/home' }],
    },
    {
      id: 2,
      title: 'Мои авто',
      children: [
        { id: 21, title: 'Мои авто', path: '/autos-mobile' },
        { id: 22, title: 'Добавить авто', path: '/auto-add-mobile' },
      ],
    },
    {
      id: 3,
      title: 'Водители',
      children: [
        { id: 31, title: 'Водители', path: '/drivers-mobile' },
        { id: 32, title: 'Добавить водителя', path: '/driver-add-mobile' },
      ],
    },
    {
      id: 4,
      title: 'Профиль',
      children: [
        { id: 41, title: 'Мой профиль', path: '/user' },
        { id: 42, title: 'Выход', clickable: true, action: 'logout' },
      ],
    },
  ],
  hidden: [
    {
      id: 2,
      title: 'Мои авто',
      children: [
        { id: 21, title: 'Мои авто', path: '/autos-mobile' },
        { id: 22, title: 'Добавить авто', path: '/auto-add-mobile' },
      ],
    },
    {
      id: 3,
      title: 'Водители',
      children: [
        { id: 31, title: 'Водители', path: '/drivers-mobile' },
        { id: 32, title: 'Добавить водителя', path: '/driver-add-mobile' },
      ],
    },
    {
      id: 4,
      title: 'Профиль',
      children: [
        { id: 41, title: 'Мой профиль', path: '/user' },
        { id: 43, title: 'Выход', clickable: true, action: 'logout' },
      ],
    },
  ],
}
